// src/services/office/factory.ts
import { OutlookAdapter, DocumentAdapter } from './adapters';
import { IOfficeContext, HostType } from '../../types/office';

export function createOfficeContext(host: HostType, userEmail?: string): IOfficeContext | null {
  console.log(`[Factory] Initializing adapter for host: ${host}`);
  console.log(`[Factory] User email provided:`, userEmail || "N/A");
  console.log(`[Factory] Office.context available:`, !!Office.context);
  console.log(`[Factory] Office.context.document available:`, !!Office.context?.document);

  if (host === "Outlook") {
    console.log(`[Factory] Outlook host detected, checking mailbox...`);
    console.log(`[Factory] Office.context.mailbox available:`, !!Office.context.mailbox);
    const item = Office.context.mailbox?.item;
    console.log(`[Factory] Outlook item retrieved:`, !!item);
    if (item) {
      console.log(`[Factory] Creating OutlookAdapter...`);
      try {
        const adapter = new OutlookAdapter(item, userEmail);
        console.log(`[Factory] OutlookAdapter created successfully`);
        return adapter;
      } catch (error) {
        console.error(`[Factory] Error creating OutlookAdapter:`, error);
        throw error;
      }
    }
    console.warn(`[Factory] No Outlook item found, returning null`);
    return null;
  } 
  
  if (host === "Word" || host === "Excel" || host === "PowerPoint") {
    console.log(`[Factory] Document host detected (${host}), creating DocumentAdapter...`);
    console.log(`[Factory] Office.context.document:`, {
      available: !!Office.context?.document,
      url: Office.context?.document?.url || "N/A",
      mode: Office.context?.document?.mode || "N/A"
    });
    
    // Check for Word-specific API availability
    if (host === "Word") {
      console.log(`[Factory] Word-specific checks:`);
      console.log(`[Factory] - typeof Word:`, typeof Word);
      console.log(`[Factory] - Word available:`, typeof Word !== 'undefined');
      console.log(`[Factory] - Office.context.document.getSelectedDataAsync:`, typeof Office.context?.document?.getSelectedDataAsync);
    }
    
    try {
      const adapter = new DocumentAdapter(host, userEmail);
      console.log(`[Factory] DocumentAdapter created successfully for ${host}`);
      return adapter;
    } catch (error) {
      console.error(`[Factory] Error creating DocumentAdapter for ${host}:`, error);
      console.error(`[Factory] DocumentAdapter error details:`, {
        error: error,
        errorMessage: error instanceof Error ? error.message : String(error),
        errorStack: error instanceof Error ? error.stack : undefined,
        host,
        userEmail
      });
      throw error;
    }
  }

  console.warn(`[Factory] Unknown host type: ${host}, returning null`);
  return null;
}